<header>
  <div class="container">
    <img src.bind="$parent.appLogo" alt="Association Insurance" />
    <!-- <h1>Advice you can trust</h1> -->
  </div>
</header>
